export enum EFrequency {
    Aucun = 1,
    Day = 2,
    Week = 3,
    Month = 4,
    Year = 5,

    // FDX
    Biweekly,
    BiMonthly,
}
